import React from 'react';

type LogoProps = {
  compact?: boolean;
};

function Logo({ compact = false }: LogoProps) {
  return (
    <span className="logo-lockup" aria-label="DailyMove">
      <svg className="logo-svg" width="48" height="48" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#126a53" />
        <path
          d="M20 44V24a12 12 0 0 1 24 0v20"
          stroke="#fff"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="26" cy="40" r="3" fill="#e6b34f" />
        <circle cx="38" cy="40" r="3" fill="#e6b34f" />
        <path d="M18 34h28" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      </svg>
      {!compact && <span>DailyMove</span>}
    </span>
  );
}

export default Logo;
